import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomerEnrichApiKey } from 'features/customers/hooks/useCustomerEnrichApiKey'
import { useCustomerEnrichApiQuota } from 'features/customers/hooks/useCustomerEnrichApiQuota'

import QuotaUsage from 'components/_base/QuotaUsage'

import NotEnabled from './NotEnabled'
import UsageUnavailable from './UsageUnavailable'

// The usage endpoint answers 400 for a customer with no Enrich key.
const CustomerEnrichApiQuotaUsage = () => {
  const { data: apiKeys, isPending: isKeyPending, isError: isKeyError } = useCustomerEnrichApiKey()
  const hasApiKey = !!apiKeys
  const { data: { usage, quota } = {}, isLoading, isError } = useCustomerEnrichApiQuota(hasApiKey)

  if (isKeyPending || (hasApiKey && isLoading)) {
    return <Skeleton variant="text" width={85} />
  }

  if (isKeyError || isError) {
    return <UsageUnavailable />
  }

  if (!hasApiKey) return <NotEnabled />

  return <QuotaUsage quota={quota} usage={usage} />
}

export default CustomerEnrichApiQuotaUsage
